module.exports = __webpack_public_path__ + "img/digitalIdentity14.35aa3fe1.png";